import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_PsychDiagnosticExam = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NBT_PsychDiagnosticExam' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">Start Time:</span>
                            <input type="text" id="txtStartTime" name="txtStartTime" className="add-only" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">End Time:</span>
                            <input type="text" id="txtEndTime" name="txtEndTime" className="add-only" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Total Time:</span>
                            <input type="text" id="txtTotalTime" name="txtTotalTime" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">Date:</span>
                            <input type="text" id="txtDate" name="txtDate" className="dpc dd" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Service Code:</span>
                            <input type="text" id="txtServiceCode" name="txtServiceCode" className="add-only" />
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Chief Complaint:</span>
                    <textarea id="txtChiefComplaint" name="txtChiefComplaint" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">HPI:</span>
                    <textarea id="txtHPI" name="txtHPI" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Past Psychiatric History:</span>
                    <textarea id="txtPastPsychHistory" name="txtPastPsychHistory" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Legal History:</span>
                    <textarea id="txtLegalHistory" name="txtLegalHistory" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Substance History:</span>
                    <textarea id="txtSubstanceHistory" name="txtSubstanceHistory" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Family History:</span>
                    <textarea id="txtFamilyHistory" name="txtFamilyHistory" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Abuse:</span>
                    <textarea id="txtAbuse" name="txtAbuse" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Medical History:</span>
                    <textarea id="txtMedicalHistory" name="txtMedicalHistory" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Medications:</span>
                    <textarea id="txtMedications" name="txtMedications" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Medication Allergies:</span>
                    <textarea id="txtMedicationAllergies" name="txtMedicationAllergies" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Social History:</span>
                    <textarea id="txtSocialHistory" name="txtSocialHistory" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Sexual History:</span>
                    <textarea id="txtSexualHistory" name="txtSexualHistory" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Mental Status:</span>
                    <textarea id="txtMentalStatus" name="txtMentalStatus" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Mood:</span>
                    <textarea id="txtMood" name="txtMood" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Affect:</span>
                    <textarea id="txtAffect" name="txtAffect" className="add-only" ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Attitude Toward Interview:</span>
                    <textarea id="txtInterviewAttitude" name="txtInterviewAttitude" className="add-only" ></textarea>
                </p>
                <h3>Diagnosis</h3>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">AXIS 1:</span>
                            <input type="text" id="txtAXISI" name="txtAXISI" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">AXIS 2:</span>
                            <input type="text" id="txtAXISII" name="txtAXISII" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">AXIS 3:</span>
                            <input type="text" id="txtAXISIII" name="txtAXISIII" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">AXIS 4:</span>
                            <input type="text" id="txtAXISIV" name="txtAXISIV" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">AXIS 5:</span>
                            <input type="text" id="txtAXISV" name="txtAXISV" className="add-only" />
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Plan:</span>
                    <textarea id="txtPlan" name="txtPlan" className="add-only" ></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-250 small">Assessor/Credentials - Print</td>
                        <td className="w-250 small">Assessor/Credentials - Signature</td>
                        <td className="w-250 small">Date</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}